import HttpService from '@/shared/services/HttpService';
class AddFundsService {
    private http = new HttpService();

    public async directa24Deposit(data: any) {
        try {

            const response = await this.http.post('payment/directa24', data);
        } catch (e) {
            return e;
        }
    }

    public async coinbaseDeposit(data: any) {
        try {
            return await this.http.post('payment/coinbase', data);
        } catch (e) {
            return e;
        }
    }

}

export default new AddFundsService();
